var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUcdenverReversed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 326.79 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CU-Denver-mark-lgr") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#d0b97c",
    points: "3.85 0 0 3.84 0 17.1 3.85 20.94 8.06 20.94 8.06 24.16 11.94 28 23.14 28 27.03 24.16 27.03 13.89 29 13.89 29 7.06 20.96 7.06 20.96 3.84 17.12 0 3.85 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#221f20",
    points: "4.01 0.4 0.4 4 0.4 16.93 4.01 20.53 8.46 20.53 8.46 24 12.1 27.6 22.98 27.6 26.63 24 26.63 13.49 28.61 13.49 28.61 7.45 20.56 7.45 20.56 4 16.96 0.4 4.01 0.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "4.42 19.54 9.45 19.54 9.45 23.58 12.51 26.61 22.57 26.61 25.63 23.58 25.63 12.5 27.61 12.5 27.61 8.45 21.54 8.45 21.54 22.56 13.5 22.56 13.5 19.54 16.54 19.54 19.56 16.52 19.56 12.5 15.51 12.5 15.51 15.5 13.5 15.5 13.5 8.45 7.45 8.45 7.45 12.5 9.45 12.5 9.45 15.5 5.43 15.5 5.43 5.4 15.51 5.4 15.51 8.45 19.56 8.45 19.56 4.42 16.54 1.39 4.42 1.39 1.39 4.42 1.39 16.52 4.42 19.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d0b97c",
    points: "13.01 19.04 16.34 19.04 19.06 16.31 19.06 13 16.02 13 16.02 15.99 13.01 15.99 13.01 8.95 7.95 8.95 7.95 12.01 9.95 12.01 9.95 15.99 4.93 15.99 4.93 4.91 16.02 4.91 16.02 7.96 19.06 7.96 19.06 4.62 16.34 1.89 4.63 1.89 1.89 4.62 1.89 16.31 4.63 19.04 9.95 19.04 9.95 23.37 12.71 26.11 22.36 26.11 25.14 23.37 25.14 12.01 27.11 12.01 27.11 8.95 22.04 8.95 22.04 23.06 13.01 23.06 13.01 19.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M39.43,6.3h1.49V16c0,3.66,1.71,5,4.59,5s4.64-1.38,4.63-5V6.3h1.49V16.35c0,3.2-1.74,6-6.12,6s-6.08-2.71-6.08-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M54.36,10.66h1.38v1.95h0a3.87,3.87,0,0,1,3.63-2.29c3.2,0,4.16,1.67,4.16,4.38V22H62.18v-7.1c0-2-.63-3.43-2.88-3.43s-3.52,1.67-3.56,3.89V22H54.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M66.21,10.66H67.6V22H66.21Zm0-4.36H67.6V8.52H66.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "68.98 10.66 70.52 10.66 74.08 20.61 74.12 20.61 77.64 10.66 79.07 10.66 74.83 22 73.36 22 68.98 10.66"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M88.59,15.53c-.06-2.08-1.36-4-3.61-4s-3.51,2-3.73,4ZM81.25,16.7c0,2,1.08,4.47,3.73,4.47a3.47,3.47,0,0,0,3.57-2.91h1.36c-.59,2.58-2.09,4.07-5,4.07-3.6,0-5.12-2.77-5.12-6,0-3,1.52-6,5.12-6s5.1,3.2,5,6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M91.85,10.66h1.26v2.65h0A4.2,4.2,0,0,1,97.4,10.5v1.39a3.91,3.91,0,0,0-4.22,3.56,4.17,4.17,0,0,0,0,.5V22H91.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M105.56,14c-.06-1.72-1.38-2.49-3-2.49-1.24,0-2.69.49-2.69,2,0,1.23,1.41,1.67,2.35,1.91l1.85.41c1.6.24,3.2,1.17,3.2,3.15,0,2.46-2.44,3.41-4.55,3.41-2.64,0-4.44-1.23-4.67-4h1.41c.1,1.88,1.49,2.84,3.34,2.84,1.3,0,3.1-.57,3.1-2.16,0-1.32-1.23-1.76-2.49-2.06l-1.77-.4c-1.81-.48-3.2-1.1-3.2-3,0-2.31,2.26-3.2,4.26-3.2,2.26,0,4.07,1.19,4.16,3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M109.37,10.66h1.39V22h-1.39Zm0-4.36h1.39V8.52h-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M115.62,10.66h2.29v1.16H115.6v7.65c0,.9.13,1.43,1.12,1.5.4,0,.79,0,1.19-.07v1.19c-.41,0-.8,0-1.23,0-1.84,0-2.48-.61-2.46-2.55V11.82h-2V10.66h2V7.25h1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M118.65,10.66h1.48l3.74,9.67,3.49-9.67h1.38l-4.91,13.07c-.8,1.92-1.26,2.47-3,2.47a4.12,4.12,0,0,1-1-.11V24.92a4.94,4.94,0,0,0,.94.12c1.23,0,1.52-.73,2-1.79l.49-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M137,16.33c0,2.4,1.32,4.84,4,4.84s4-2.4,4-4.84-1.32-4.84-4-4.84-4,2.4-4,4.84m9.34,0c0,3.25-1.89,6-5.37,6s-5.36-2.75-5.36-6,1.89-6,5.36-6,5.37,2.75,5.37,6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M152.83,11.82h-2.25V22H149.2V11.82h-1.94V10.66h1.94v-1c0-2,.52-3.32,2.75-3.32a9,9,0,0,1,1.16.08v1.2a5.69,5.69,0,0,0-1-.12c-1.54,0-1.5,1-1.52,2.2v1h2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M172,11.05a4.8,4.8,0,0,0-4.8-3.81c-4.16,0-5.92,3.48-5.92,6.91s1.76,6.9,5.92,6.9c2.9,0,4.75-2.24,5-5h1.51c-.43,3.85-2.87,6.31-6.54,6.31-4.95,0-7.41-3.89-7.41-8.18S162.25,6,167.2,6c3,0,5.91,1.78,6.31,5.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M176.55,16.33c0,2.4,1.32,4.84,4,4.84s4-2.4,4-4.84-1.32-4.84-4-4.84-4,2.4-4,4.84m9.34,0c0,3.25-1.88,6-5.36,6s-5.36-2.75-5.36-6,1.89-6,5.36-6,5.36,2.75,5.36,6"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    x: 187.99,
    y: 6.3,
    width: 1.38,
    height: 15.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M192.84,16.33c0,2.4,1.32,4.84,4,4.84s4-2.4,4-4.84-1.32-4.84-4-4.84-4,2.4-4,4.84m9.35,0c0,3.25-1.89,6-5.36,6s-5.34-2.71-5.34-6,1.89-6,5.37-6,5.37,2.75,5.37,6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M204.29,10.66h1.28v2.65h0a4.2,4.2,0,0,1,4.28-2.81v1.39a3.89,3.89,0,0,0-4.21,3.56,2.79,2.79,0,0,0,0,.5V22h-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M218.44,15.8h0c-.18.33-.8.44-1.17.5-2.35.43-5.28.4-5.28,2.62a2.41,2.41,0,0,0,2.53,2.25c2.11,0,4-1.35,4-3.57Zm-7.38-1.67c.12-2.67,2-3.81,4.59-3.81,2,0,4.17.62,4.17,3.66v6a.74.74,0,0,0,.64.83h.16a1.64,1.64,0,0,0,.44-.09v1.16a3.32,3.32,0,0,1-.89.09c-1.41,0-1.6-.8-1.6-2h0a4.34,4.34,0,0,1-4.14,2.31c-2.09,0-3.81-1-3.81-3.32,0-3.2,3.11-3.3,6.1-3.65,1.14-.13,1.78-.29,1.78-1.54,0-1.87-1.34-2.33-3-2.33s-3,.8-3,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M227.21,21.17c3,0,4-2.49,4-4.84s-1-4.84-4-4.84c-2.64,0-3.71,2.49-3.71,4.84s1.07,4.84,3.71,4.84m5.37.8h-1.27V19.85h-.05a4.48,4.48,0,0,1-4,2.48c-3.44,0-5.1-2.8-5.1-6s1.66-6,5.1-6a4.05,4.05,0,0,1,3.94,2.49h0V6.3h1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M236,16.33c0,2.4,1.32,4.84,4,4.84s4-2.4,4-4.84-1.32-4.84-4-4.84-4,2.4-4,4.84m9.34,0c0,3.25-1.89,6-5.37,6s-5.33-2.71-5.33-6,1.89-6,5.36-6,5.37,2.75,5.37,6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M257.21,19.09h3.07c2,0,3.91-1.23,3.91-4.7,0-3.2-1.1-5.19-4.53-5.19H257.2ZM253.76,6.3h6.77c4.07,0,7.12,2.55,7.12,7.76,0,4.55-2.32,7.94-7.12,7.94h-6.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M277.38,15.09c-.3-1.59-1-2.39-2.49-2.39A2.45,2.45,0,0,0,272.3,15a.17.17,0,0,0,0,.07Zm-5.1,2c.08,2,1.05,2.89,2.79,2.89a2.57,2.57,0,0,0,2.46-1.48h2.75A5.12,5.12,0,0,1,275,22.31c-3.59,0-5.81-2.46-5.81-6a5.65,5.65,0,0,1,5.81-6c3.87,0,5.73,3.26,5.52,6.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M282.35,10.63h3v1.6h.07a4,4,0,0,1,3.47-1.89c3.33,0,4.16,1.87,4.16,4.68v7h-3.14v-6.4c0-1.87-.55-2.8-2-2.8-1.69,0-2.4,1-2.4,3.26V22h-3.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "301.67 22 298.2 22 294.31 10.63 297.58 10.63 299.98 18.39 300.02 18.39 302.42 10.63 305.52 10.63 301.67 22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M314.47,15.09c-.29-1.59-1-2.39-2.48-2.39a2.46,2.46,0,0,0-2.6,2.32v.07Zm-5.08,2c.09,2,1.06,2.89,2.79,2.89a2.59,2.59,0,0,0,2.49-1.48h2.75a5.11,5.11,0,0,1-5.32,3.83c-3.58,0-5.81-2.46-5.81-6a5.65,5.65,0,0,1,5.81-6c3.86,0,5.74,3.26,5.52,6.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M319.47,10.63h3v2.11h0a4,4,0,0,1,3.63-2.4,2.62,2.62,0,0,1,.68.12v2.9a6.07,6.07,0,0,0-1.12-.11c-2.29,0-3.08,1.64-3.08,3.65V22h-3.12Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUcdenverReversed);
export default __webpack_public_path__ + "static/media/ucdenver-reversed.9d2d53f3e3713ec62c096670c6e12959.svg";
export { ForwardRef as ReactComponent };